export default {
  id: 198,
  title: 'Target #198 - Walls',
  url: 'https://cssbattle.dev/play/198',
  colors: ['#6867D4', '#7BAFDE', '#000039'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{height:100}p[a],p[c]{width:100}p[b],p[c]{background:#7bafde;transform:skewY(26.5deg);box-shadow:350px -200px #7bafde}body{background:#6867d4}p{position:fixed}p[a]{top:84;left:50;background:#000039;transform:skewY(-26.5deg);box-shadow:200px 100px #000039}p[b]{top:96;left:0;width:50}p[c]{top:34;left:150;height:200',
}
